import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeAcademyToSoftwareModal, openAcademyToSoftwareModal
//@ts-expect-error Could not find declaration file for module
} from '../../actions/AcademyToSoftware';
//@ts-expect-error Could not find declaration file for module
import { getIsAcademyToSoftwareModalOpen } from '../../selectors/academyToSoftwareSelectors';
import SoftwareDesirabilityButton from './SoftwareDesirabilityButton';
import SoftwareDesirabilityModal from './SoftwareDesirabilityModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyToSoftware = ({
  isModalOpen,
  openAcademyToSoftwareModal: openModal,
  closeAcademyToSoftwareModal: closeModal,
  use = 'button',
  selectedField
}) => {
  useEffect(() => {
    return () => {
      closeModal();
    };
  }, [closeModal]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SoftwareDesirabilityButton, {
      setModalOpen: () => {
        if (openModal) {
          openModal('NAV_CTA', selectedField);
        }
      },
      use: use
    }), isModalOpen && /*#__PURE__*/_jsx(SoftwareDesirabilityModal, {
      onClose: closeModal
    })]
  });
};
AcademyToSoftware.propTypes = {
  closeAcademyToSoftwareModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
  openAcademyToSoftwareModal: PropTypes.func.isRequired,
  use: PropTypes.oneOf(['button', 'inline', 'inline-link'])
};
const mapStateToProps = state => ({
  isModalOpen: getIsAcademyToSoftwareModalOpen(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({
  openAcademyToSoftwareModal,
  closeAcademyToSoftwareModal
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AcademyToSoftware);